export default __webpack_public_path__ + "content/9572470e485d8e0fd2adc5b2559bb072.ttf";